import { render, staticRenderFns } from "./AiGetSuggestions.vue?vue&type=template&id=1654d6ae&scoped=true"
import script from "./AiGetSuggestions.vue?vue&type=script&lang=js"
export * from "./AiGetSuggestions.vue?vue&type=script&lang=js"
import style0 from "./AiGetSuggestions.vue?vue&type=style&index=0&id=1654d6ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1654d6ae",
  null
  
)

export default component.exports